import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";

const { Dragger } = Upload;

const allowedFileTypes = ["application/pdf", "image/png", "image/jpeg"];

const props = {
  name: "file",
  multiple: false,
  accept: allowedFileTypes.join(", "),
  beforeUpload: () => false,
  onDrop(e) {},
};

const DocumentUpload = ({ onChange }) => (
  <Dragger
    {...props}
    className="bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white"
    showUploadList={false}
    onChange={onChange}
  >
    <p className="ant-upload-drag-icon">
      <InboxOutlined />
    </p>
    <p className="text-zinc-900 dark:text-white">
      Click or drag file to this area to upload
    </p>
    <p className="text-zinc-900 dark:text-white">
      Allowed file types: PNG, PDF, JPEG.
    </p>
  </Dragger>
);

export { DocumentUpload };
